import { z } from 'zod'
import { type PdvPermission } from '../../models/PdvPermission'
import { mapPdvPermissionToDomain, mapPdvPermissionToSubDomain } from '../../composables/usePdvPermission'

export const PdvPermissionDTO = z.object({
  name: z.string(),
  description: z.string()
})

export type PdvPermissionDTO = z.infer<typeof PdvPermissionDTO>

export function mapPdvPermissionToDTO (model: PdvPermission): string {
  return model.name
}

export function mapDTOToPdvPermission (dto: PdvPermissionDTO): PdvPermission {
  const domain = mapPdvPermissionToDomain(dto.name)
  const subDomain = mapPdvPermissionToSubDomain(dto.name)

  return {
    name: dto.name,
    description: dto.description,
    domain,
    subDomain
  }
}

export function createPdvPermissionFromName (name: string, description: string): PdvPermission {
  return mapDTOToPdvPermission({ name, description })
}
